module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"clearFilter":"Clear Filter"},"de":{"clearFilter":"Filter zurücksetzen"},"fr":{"clearFilter":"Enlever le filtre"},"it":{"clearFilter":"Elimina filtro"}}')
  delete Component.options._Ctor
}
